import type { ReactNode } from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './Dialog'

type UnsavedChangesDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: ReactNode
  description: ReactNode
  keepEditingLabel: ReactNode
  discardLabel: ReactNode
  onKeepEditing: () => void
  onDiscard: () => void
}

export function UnsavedChangesDialog({
  open,
  onOpenChange,
  title,
  description,
  keepEditingLabel,
  discardLabel,
  onKeepEditing,
  onDiscard,
}: UnsavedChangesDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <button
            type="button"
            className="rounded-md border border-input px-4 py-2 text-sm font-medium text-muted-foreground hover:bg-accent focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/60"
            onClick={onKeepEditing}
          >
            {keepEditingLabel}
          </button>
          <button
            type="button"
            className="rounded-md bg-destructive px-4 py-2 text-sm font-medium text-destructive-foreground hover:bg-destructive/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-destructive/60"
            onClick={onDiscard}
          >
            {discardLabel}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
